import { render } from "./security.vue?vue&type=template&id=b459ca50&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"

import "./security.vue?vue&type=style&index=0&id=b459ca50&lang=css"
import "./security.vue?vue&type=style&index=1&id=b459ca50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b459ca50"]])

export default __exports__